export default __webpack_public_path__ + "dist/media/Shield.3689f766.svg";